<template>
  <v-container fluid v-if="dataSource">
    <v-row no-gutters>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            {{ $t("servicesystem.common_objects.kpi.kpi") }}
          </v-card-title>
          <v-card-text>
            <DxChart ref="chart">
              <DxTooltip :enabled="true" :customize-tooltip="customizeTooltip" />
              <DxAdaptiveLayout :width="450" />
              <DxSize :height="200" />
              <DxCommonSeriesSettings type="bar" />
            </DxChart>

            <DxPivotGrid id="pivotgrid"
              :height="500"
              ref="grid"
              :data-source="dataSource"
              :allow-sorting-by-summary="true"
              :allow-filtering="true"
              :show-borders="true"
              :show-column-grand-totals="false"
              :show-row-grand-totals="false"
              :show-row-totals="false"
              :show-column-totals="false">
              <DxFieldChooser :enabled="true"
                :height="400" />
            </DxPivotGrid>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
import { DxAdaptiveLayout, DxChart, DxCommonSeriesSettings, DxSize, DxTooltip } from "devextreme-vue/chart";

import { DxFieldChooser, DxPivotGrid } from "devextreme-vue/pivot-grid";

import client from "@/api/client";
export default {
  name: "Graph",
  components: {
    DxChart,
    DxAdaptiveLayout,
    DxCommonSeriesSettings,
    DxPivotGrid,
    DxFieldChooser,
    DxSize,
    DxTooltip,
  },
  props: [],
  data() {
    return {
      queryPreset: {
        JobStatuses: ['Completed'],
        VolumeDateType: 'Month',
        Month: (new Date()).getMonth() + 1,
        Year: (new Date()).getFullYear(),
        GroupBy: 'Completed'
      },
      dataSource: {
        fields: [],
        store: [],
      },
    };
  },
  mounted() {
    this.getByPreset(this.queryPreset);
  },
  methods: {
    getByPreset(preset) {
      const statuses = 'JobStatuses=' + preset.JobStatuses.join('&JobStatuses=');
      client()
        .get(`/api2/serviceprovider/statistics/kpiCustomer?${statuses}&VolumeDateType=${preset.VolumeDateType}&Month=${preset.Month}&GroupBy=${preset.GroupBy}&Year=${preset.Year}`)
        .then((response) => {
          if (!response.data) return;
          const data = {
            fields: [
              {
                caption: this.$t("servicesystem.common_objects.customer.parent_org"),
                dataField: "parentCustomer",
                width: 250,
                area: "row",
              },
              {
                caption: this.$t("servicesystem.common_objects.customer.customer"),
                dataField: "customer",
                width: 550,
                area: "row",
              },
              {
                dataField: "date",
                dataType: "date",
                area: "column",
                groupInterval: "month"
              },
              {
                groupName: "parentCustomer",
                visible: true,
              },
              {
                caption:  this.$t("servicesystem.common_objects.kpi.total"),
                dataField: "value",
                dataType: "number",
                summaryType: "sum",
                format: {
                  type: "currency",
                  precision: 2,
                  currency: this.$store.state.GlobalSettings.CurrencyFormat
                },
                area: "data",
              },
            ],
            store: response.data.map((v) => {
              v.date = new Date(v.date);
              return v;
            }),
          };
          //console.log(data);
          this.dataSource = data;
          const pivotGrid = this.$refs.grid.instance;
          const chart = this.$refs.chart.instance;
          pivotGrid.bindChart(chart, {
            dataFieldsDisplayMode: "splitPanes",
            alternateDataFields: false,
          });
        });
    },
    customizeTooltip(args) {
      //console.log(args);
      return {
        text: `Day: ${args.argumentText}<br/>Total: ${args.total}`
      }
    }
  },

  computed: {},

  watch: {},
};
</script>


<style lang='scss' scoped></style>